import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import GroupAddIcon from '@material-ui/icons/GroupAdd'
import Autocomplete from '@material-ui/lab/Autocomplete'
import React from 'react'
import { useActions, useValues } from 'kea';
import CircularProgress from '@material-ui/core/CircularProgress';

import grouplogic from 'src/store/group'

const AssignGroupDialog = ({ vehicle, onGroupAssign }) => {
	// const [vehicle, setVehicle] = useState(props.vehicle);
	const [open, setOpen] = React.useState(false);

	const { groups } = useValues(grouplogic);
	const { fetchAll: groupFetchAll } = useActions(grouplogic);

	const [newGroups, setNewGroups] = React.useState(vehicle.groups.map((g) => g._id) || []);

	React.useEffect(() => {
		groups ?? groupFetchAll();
	}, []) // eslint-disable-line

	const handleClickOpen = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
	}

	const handleChange = (e, newValue) => {
		// console.log(newValue);
		// let update_groups = [...newGroups];
		const update_groups = newValue;
		setNewGroups(update_groups);
	}

	const handleEdit = () => {
		setOpen(false);
		vehicle.groups = newGroups;
		// console.log(vehicle);
		// vehicle.tracker = tracker;
		onGroupAssign(vehicle);
	}

	if (groups === null) {
		return <CircularProgress />
	}

	return (
		<div>
			<Tooltip title="Assign vehicle to Group(s)">
				<IconButton aria-label="delete" onClick={handleClickOpen} size='small'>
					<GroupAddIcon />
				</IconButton>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">Assign this vehicle to Group(s)</DialogTitle>
				<DialogContent>
					<Autocomplete
						multiple
						id="tags-standard"
						options={groups.map((g) => g._id)}
						getOptionLabel={(option) => {
							return groups.filter((g) => {
								return g._id === option;
							})[0].name
						}}
						// defaultValue={vehicle.groups}
						size={'medium'}
						value={newGroups}
						filterSelectedOptions
						onChange={handleChange}
						renderInput={(params) => (
							<TextField
								{...params}
								variant="standard"
								label="Select Groups"
							// placeholder=""
							/>
						)}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleEdit} color="primary">
						Assign
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}

export default AssignGroupDialog
